<template>
    <div class="page_list list_page">
        <div class="page_top">
            <div class="title">個人設定</div>
            <div class="set_info">
                <!-- <p class="tag pass"><i class="el-icon-star-on"></i>合格司機</p> -->
                <p class="tag"><i class="el-icon-star-on"></i>一般會員</p>
                <p class="tit">{{userInfo.name || '新用戶'}}<span>({{userInfo.nickname || '暫無暱稱'}})</span></p>
            </div>
        </div>
        <ul class="set_list">
            <li class="item" @click="goToUserInfo()"><i class="icon user"></i>帳號個人資料</li>
            <li class="item" @click="changPassword()"><i class="icon chang"></i>變更密碼</li>
            <li class="item" @click="goToMemberGift()"><i class="icon el-icon-present" style="color: #03AF4D"></i>我的獎品</li>
            <li class="item" @click="checkVersion()"><i class="icon el-icon-warning-outline" style="color: #03AF4D"></i>目前版本</li>
            <li class="item" @click="goToHelpInfo()"><i class="icon info"></i>鹿路小助手</li>
            <li class="item" @click="signOut()"><i class="icon out"></i>登出帳號</li>

        </ul>
        <MENU/>
    </div>
</template>
<script>
    import FN from '@/components/fn'
    import {mapActions, mapGetters} from 'vuex'
    import MENU from '@/components/menu.vue'

    export default {
        name: 'SetList',
        components: {
            MENU
        },
        mixins: [FN],
        data() {
            return {}
        },
        mounted() {
            this.getUserInfo()
        },
        computed: {
            ...mapGetters([
                'userInfo'
            ])
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            goToUserInfo() {
                const {href} = this.$router.resolve({name: 'UserSet'})
                window.open(href, '_self')
            },
            changPassword() {
                const {href} = this.$router.resolve({name: 'ChangePassword'})
                window.open(href, '_self')
            },
            signOut() {
                this.FETCH({
                    key: 'SIGN_OUT',
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.signOut)
                    } else {
                        this.handleResponse(res)
                    }
                })
            },
            handleResponse(res) {
                if (!+res.code) {
                    this.$confirm('帳號已登出', {
                        closeOnPressEscape: false,
                        showClose: false,
                        closeOnClickModal: false,
                        showCancelButton: false,
                        type: 'success'
                    })
                        .then(() => {
                            const {href} = this.$router.resolve({name: 'Login'})
                            window.open(href, '_self')
                        })
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            getUserInfo() {
                this.FETCH({
                    key: 'USER_INFO',
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getUserInfo)
                    }
                })
            },
            checkVersion() {
                try {
                    window.flutter_inappwebview.callHandler('getVersion', '').then(function (result) {
                        if (result !== null) {
                            var version = JSON.parse(result);
                            alert('目前版本為 v' + version.version);
                        } else {
                            alert('無版號資訊');
                        }
                    });
                } catch (e) {
                    alert('無版號資訊。');
                }

            },
            goToMemberGift() {
                const {href} = this.$router.resolve({name: 'MemberGift'})
                window.open(href, '_self')
            },
            goToHelpInfo() {
                const {href} = this.$router.resolve({name: 'help'})
                window.open(href, '_self')
            },
        }
    }
</script>
